"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var value_checker_1 = __importDefault(require("../validation/value_checker"));
var SalesForceContactApplyObject = /** @class */ (function () {
    function SalesForceContactApplyObject() {
    }
    SalesForceContactApplyObject.create = function (contractDocument, salesForceInfo) {
        var baseObject = {
            AccountId: salesForceInfo.corporateId,
            LastName: contractDocument.officeInfoRequestPersonLastName,
            FirstName: contractDocument.officeInfoRequestPersonFirstName,
            NameKana__c: contractDocument.officeInfoRequestPersonKanaLastName + " " + contractDocument.officeInfoRequestPersonKanaFirstName,
            Email: contractDocument.officeInfoRequestEmail
        };
        if (value_checker_1.default.isPresent(salesForceInfo.applyTorihikisakiId)) {
            baseObject['Id'] = salesForceInfo.applyTorihikisakiId;
        }
        else {
            baseObject['OwnerId'] = salesForceInfo.lastUpdateUser;
        }
        return baseObject;
    };
    return SalesForceContactApplyObject;
}());
exports.default = SalesForceContactApplyObject;



//////////////////
// WEBPACK FOOTER
// ./common/src/utils/sales_force/contact_apply_object.ts
// module id = w5GM
// module chunks = 1